import { useAtomValue } from 'jotai';

import { authStateResolvedAtom } from '@/services/globalState';

/** Whether sign-in has settled, for features that wait to act until the account is known. */
export function useAuthResolved() {
  return useAtomValue(authStateResolvedAtom);
}
